import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, CENTER } from '../structure/cell';
import Translation from '../../translation/translation';

export function AddServiceFittingStation({
    onLearnMoreClick,
    onAddServiceFittingStationClick,
    hasBorder,
}) {
    return (
        <Row
            className="add-service-fitting-station"
            hasBorder={hasBorder}
        >
            <Cell side={CENTER} colSpan={3}>
                <div className="add-service-fitting-station__headline" onClick={onAddServiceFittingStationClick}>
                    <span className="add-service-fitting-station__hot-badge">Hot</span>
                    <Translation
                        className="sidebar__row-headline"
                        translationKey="pdp-sidebar-add-service-fitting-station-headline"
                    />
                </div>
                <div className="add-service-fitting-station__text">
                    <Translation translationKey="pdp-sidebar-add-service-fitting-station-text" />

                    <Translation
                        className="add-service-fitting-station__learn-more"
                        onClick={onLearnMoreClick}
                        translationKey="pdp-sidebar-add-service-fitting-station-learn-more"
                    />
                </div>
            </Cell>
        </Row>
    );
}

AddServiceFittingStation.propTypes = {
    onLearnMoreClick: PropTypes.func.isRequired,
    onAddServiceFittingStationClick: PropTypes.func.isRequired,
    hasBorder: PropTypes.bool,
};

AddServiceFittingStation.defaultProps = {
    hasBorder: true,
};
